/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuctionDto } from '../../models/auction-dto';

export interface GetAuction$Params {
  id: number;
  'X-API-Version'?: string;
}

export function getAuction(http: HttpClient, rootUrl: string, params: GetAuction$Params, context?: HttpContext): Observable<StrictHttpResponse<AuctionDto>> {
  const rb = new RequestBuilder(rootUrl, getAuction.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AuctionDto>;
    })
  );
}

getAuction.PATH = '/api/auctions/{id}';
